/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Nick Cattaneo, Thomas Barry
*/
export var FORM_CREATE = 'FORM_CREATE';
export var FORM_DELETE = 'FORM_DELETE';
export var FORM_CHANGE = 'FORM_CHANGE';
export var FORM_SUBMIT = 'FORM_SUBMIT';
export var FORM_VALIDATE = 'FORM_VALIDATE';
export var FORM_SUBMIT_START = 'FORM_SUBMIT_START';
export var FORM_SUBMIT_END = 'FORM_SUBMIT_END';
export var createForm = function createForm(payload) {
  return {
    type: FORM_CREATE,
    payload: payload
  };
};
export var deleteForm = function deleteForm(payload) {
  return {
    type: FORM_DELETE,
    payload: payload
  };
};
export var validateForm = function validateForm(payload) {
  return {
    type: FORM_VALIDATE,
    payload: payload
  };
};
export var changeForm = function changeForm(payload) {
  return {
    type: FORM_CHANGE,
    payload: payload
  };
};
export var submitForm = function submitForm(payload) {
  return {
    type: FORM_SUBMIT,
    payload: payload
  };
};
export var formSubmitStart = function formSubmitStart(payload) {
  return {
    type: FORM_SUBMIT_START,
    payload: payload
  };
};
export var formSubmitEnd = function formSubmitEnd(payload) {
  return {
    type: FORM_SUBMIT_END,
    payload: payload
  };
};